<template>
  <div>
    <div v-if="!loaded">Chargement ...</div>
    <img :src="src" v-if="loaded && found"/>
    <NotFoundView v-if="loaded && !found"/>
  </div>
</template>

<script>
import api from '../store/api'
import NotFoundView from './404.vue'
export default {
  components: {
    NotFoundView,
  },
  data () {
    return {
      src: 'https://www.newton.ac.uk/files/covers/968361.jpg',
      loaded: false,
    }
  },
  mounted () {
    const photoId = this.$route.params.id
    if (photoId !== null && photoId !== undefined) {
      api.getPhotoById(photoId).then((res) => {
        console.log(res)
        if (res.data !== undefined) {
          this.found = true
          this.src = res.data.data
        } else {
          this.found = false
        }
        this.loaded = true
      }, (err) => {
        console.error(err)
        this.loaded = true
        this.found = false
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// Photo.vue?4aba56b6